import { Link } from 'react-router-dom';

export default function CTATimeline() {
  const handlePrint = () => {
    window.print();
  };

  return (
    <section className="py-20 bg-gradient-to-br from-violet-50 via-purple-50 to-fuchsia-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Continue sua Jornada de Transformação
          </h2>
          <p className="text-xl text-gray-600">
            Explore outras técnicas poderosas de PNL
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <Link
            to="/worksheet-ressignificacao"
            className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-2 border-transparent hover:border-violet-200"
          >
            <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-2xl flex items-center justify-center mb-4">
              <i className="ri-refresh-line text-white text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Ressignificação (Reframing)
            </h3>
            <p className="text-gray-600 mb-4">
              Mude o significado de situações limitantes e encontre novas perspectivas empoderadoras
            </p>
            <div className="flex items-center gap-2 text-violet-600 font-semibold">
              <span>Acessar Worksheet</span>
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>

          <Link
            to="/worksheet-swish"
            className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-2 border-transparent hover:border-violet-200"
          >
            <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-2xl flex items-center justify-center mb-4">
              <i className="ri-flashlight-line text-white text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Técnica Swish
            </h3>
            <p className="text-gray-600 mb-4">
              Substitua padrões mentais indesejados por respostas automáticas fortalecedoras
            </p>
            <div className="flex items-center gap-2 text-violet-600 font-semibold">
              <span>Acessar Worksheet</span>
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>

          <Link
            to="/planos#exercicios-pnl"
            className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-2 border-transparent hover:border-violet-200"
          >
            <div className="w-16 h-16 bg-gradient-to-br from-fuchsia-500 to-pink-600 rounded-2xl flex items-center justify-center mb-4">
              <i className="ri-brain-line text-white text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Submodalidades
            </h3>
            <p className="text-gray-600 mb-4">
              Ajuste os controles internos da sua mente e transforme experiências negativas
            </p>
            <div className="flex items-center gap-2 text-violet-600 font-semibold">
              <span>Ver Exercício</span>
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/planos#exercicios-pnl"
            className="bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white px-8 py-4 rounded-full font-semibold hover:shadow-xl transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            Ver Todos os Exercícios de PNL
          </Link>
          <button
            onClick={handlePrint}
            className="bg-white text-violet-600 px-8 py-4 rounded-full font-semibold hover:shadow-lg transition-all duration-300 border-2 border-violet-200 whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-printer-line"></i>
            Imprimir Worksheet
          </button>
        </div>
      </div>
    </section>
  );
}
